
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AddressType } from "@/dtos/addressType";
import { AddressDto } from "@/dtos/addressDto";
import EditAddressComponent from "@/components/EditAddressComponent.vue";

@Component({
	components: {
		EditAddressComponent,
	},
})
export default class AddressTile extends Vue {
	@Prop()
	private type!: AddressType;
	@Prop()
	private propAddress!: AddressDto;
	private address: AddressDto = new AddressDto();
	private customerPersonalType: AddressType = AddressType.CustomerPersonal;
	private customerDeliveryType: AddressType = AddressType.CustomerDelivery;
	private customerInvoiceType: AddressType = AddressType.CustomerInvoice;
	private orderDeliveryType: AddressType = AddressType.OrderDelivery;
	private orderInvoiceType: AddressType = AddressType.OrderInvoice;
	private currentEditAddress: AddressDto = new AddressDto();
	private editAddressDialog: boolean = false;
	private userCanChangeDeliveryAddress: boolean = false;
	private userCanChangeInvoiceAddress: boolean = false;

	private mounted() {
		this.address = JSON.parse(JSON.stringify(this.propAddress));
	}

	private get hasName() {
		return this.address.givenName !== "" || this.address.surname !== "";
	}

	private openEditDialog() {
		this.currentEditAddress = JSON.parse(JSON.stringify(this.address));
		this.editAddressDialog = true;
	}

	private reloadAddress(address: AddressDto) {
		if (address.companyName === "") {
			address.companyName = "privat";
		}
		this.address = JSON.parse(JSON.stringify(address));
	}
}
